<template>
<div class="navbar-popup" style="width:300px">
  <div class="navbar-popup-title">
  账户信息
  <div style="float:right"> 
    <el-button type="text" @click="showChangePassword">修改密码</el-button>
    <el-button type="text" @click="showAccountInfo">账户设置</el-button>
  </div>
 
  </div>
  <div class="navbar-popup-content">
    <ul style="    list-style-type: disc;list-style-position:inside;">
      <li>
      角色：<span class="info">{{rolesName}}</span>
      </li>
      <li>
      本次登录：<span class="info">{{profile.loginTime}}</span>
      </li>
      <li>
      登录地区：<span class="info">{{profile.region}} {{profile.loginIp}}</span>
      </li>
      <li>
        上次登录：<span class="info">{{profile.lastLoginTime}}</span>
      </li>
    </ul>
  </div>
    <!-- <ChangePassword   @successTell="successTell" :dialogControl="formDialogControl" :formTemp="formTemp"></ChangePassword> -->
    <!-- 修改密码弹窗 -->
    <ChangePassword :dialogControl="changePasswordDialogControl"></ChangePassword>
    <AccountInfo :dialogControl="accountInfoDialogControl"></AccountInfo>
</div>
</template>
<script>
import ChangePassword from '../Account/ChangePassword'// 引入修改用户密码的弹窗组件
import AccountInfo from '../Account/AccountInfo'
export default {
  components: { ChangePassword, AccountInfo },
  props: {
    profile: {
      type: Object,
      required: true
    }
  },
  computed: {
    rolesName: function() {
      const names = []
      if (this.profile.role) {
        for (const v in this.profile.role) names.push(this.profile.role[v])
      }
      return names.join(',')
    }
  },
  data: function() {
    return {
      changePasswordDialogControl: {
        dialogVisible: false
      },
      accountInfoDialogControl: {
        dialogVisible: false
      }
    }
  },
  methods: {
    showChangePassword() {
      this.changePasswordDialogControl.dialogVisible = true
    },
    showAccountInfo() {
      this.accountInfoDialogControl.dialogVisible = true
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.userinfo {
  margin: 0px;
  padding: 0px;
  width: 150px;
  //color: rgb(170, 169, 169);
  font-size: 15px;
  font-weight: 600;
}
</style>
<style lang="scss">
$color:black;
.account-info{
    .ivu-select-dropdown{
      background-color: white;
    }
    .navbar-popup{
      background: white;
    }
    .navbar-popup-title{
      background: white;
      color:$color!important;
    }
    .navbar-popup-content{
      li{
        color:$color!important;
        .info{
          color:$color!important;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar/PopAccount.vue